CONSTService.$inject = ['_', 'API', 'Club', 'User'];

/* @ngInject */
function CONSTService(_, API, Club, User) {
    var CONST = this;
    CONST.$install = install;
    CONST.$info = info;
    CONST.$uninstall = info;

    CONST.STATIC = {
        PATH: '/uploads/',
        AVATAR_PATH: '/avatars/',
        AVATAR_DEFAULT: 'no-avatar.png',
        LOGO_PATH: 'clubs/',
        LOGO_DEFAULT: 'no-logo.png',
        $logo: function (logo) {
            var STATIC = CONST.STATIC;
            return (
                STATIC.PATH +
                STATIC.LOGO_PATH +
                (logo ? logo : STATIC.LOGO_DEFAULT)
            );
        },
        BG_PATH: 'clubs/bg/',
        BG_DEFAULT: 'bg_default.jpeg',
        $bg: function (bg) {
            var STATIC = CONST.STATIC;
            return STATIC.PATH + STATIC.BG_PATH + (bg ? bg : STATIC.BG_DEFAULT);
        },
    };

    ////////////////

    /**
     * Installs the constats, and the Club and User if available
     * @method install
     * @param  {Object} info
     */
    function install(info, growthbookData = null) {
        _.extend(CONST, _.omit(info, ['user', 'club']));
        CONST._loaded = true;

        if (info.club) Club.install({ ...info.club, growthbookData });
        if (info.user && window._backoffice.is_logged_in)
            User.install(info.user);
    }

    /**
     * Fetches the info endpoint with static data depending on the club.
     * It merges it into the Constants and installs them
     * @method info
     * @param  {Object} opts
     * @param  {Boolean} opts.user Include/exclude user data (if logged in) default=true
     * @param  {Boolean} opts.only_club Exclude user and constants leaving only the club default=false
     * @return {Promise}
     */
    async function info(opts) {
        opts = angular.extend(
            {
                user: true,
                only_club: false,
            },
            opts,
        );
        var permalink = window.location.pathname.split('/').pop();

        var growthbookData = null;
        const origin = window.location.origin;

        const isLocalHostOrBeta =
            origin.includes('127.0.0.1') ||
            origin.includes('localhost') ||
            origin.includes('beta');

        const growthbookSDK = isLocalHostOrBeta
            ? 'sdk-56up9IdDZvJ4IPZ'
            : 'sdk-1oAGHYofMzyXUYa9';
        try {
            const growthbook = await fetch(
                `https://cdn.growthbook.io/api/features/${growthbookSDK}`,
                {
                    headers: {
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        Pragma: 'no-cache',
                        Expires: '0',
                    },
                },
            );

            if (!growthbook.ok) {
                throw new Error('Failed to fetch Growthbook data');
            }

            const data = await growthbook.json();
            growthbookData = data;
        } catch (error) {
            console.log('Error fetching Growthbook data:', error);
        }

        const info = await API.one('sportclubs', permalink).customGET('info', {
            user: opts.user,
            only_club: opts.only_club,
        });

        install(info.plain(), growthbookData);
        return info.plain();
    }
}

export default CONSTService;
